import { partner_images } from "../../../Assets/Partners/ImageLoader";

export const ReferenceImages: string[] = partner_images;
